import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  rightArrow,
  rightArrowHover,
} from '../../../assets/images';
import { useParams } from 'react-router-dom';
import axios from 'axios';

// SWIPER
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const ProjectDetailItems = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { id } = useParams();

  const [news, setNews] = useState([]);
  const [singleNews, setSingleNews] = useState(null);

  // Çox dilli alanlar
  const getLocalizedField = (item, fieldBase) => {
    if (!item) return "";
    if (currentLanguage === 'en') return item?.[`${fieldBase}En`] || item?.[fieldBase] || "";
    if (currentLanguage === 'ru') return item?.[`${fieldBase}Ru`] || item?.[fieldBase] || "";
    return item?.[fieldBase] || "";
  };

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Projects`,
        { withCredentials: false }
      );

      const data = response.data;
      setNews(data);

      const filtered = data?.find(product => String(product.id) === String(id));
      setSingleNews(filtered || null);

    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <div className='pt-[56px] md:pt-[88px] bg-[#F9F9F9]'>
      <div className='max-w-containerSm md:max-w-container mx-auto'>

        {/* TOP SECTION */}
        <div className='md:flex justify-between gap-5'>
          
          {/* TEXT */}
          <div className='md:w-[50%] text-[#1C1C1C]'>
            <p className='text-[26px] font-medium'>
              {getLocalizedField(singleNews, "title")}
            </p>

            <div
              className='mt-6'
              dangerouslySetInnerHTML={{
                __html: getLocalizedField(singleNews, "description")
              }}
            />
          </div>

          {/* SWIPER */}
          <div className='md:w-[50%] mt-10 md:mt-0'>
            {singleNews?.images?.length > 0 && (
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000 }}
                loop
                spaceBetween={10}
                slidesPerView={1}
                className="rounded-[12px]"
              >
                {singleNews.images.map((img, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={`https://cortex-site.runasp.net/${img}`}
                      className="w-full h-[300px] md:h-[450px] object-cover rounded-[12px]"
                      alt=""
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>

        </div>

        {/* OTHER PROJECTS HEADER */}
        <div className='flex justify-between items-center mt-[104px]'>
          <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>
            {t("Digər layihələr")}
          </p>

          <a className='hidden md:block group' href={`/${currentLanguage}/projects`}>
            <div className='flex justify-between items-center w-[164px] rounded-[12px] bg-[#FBFBFB] text-[#1C1C1C] h-[46px] px-3'>
              <p className='transition-colors duration-300 group-hover:text-[#2a3d63]'>
                {t("Hamısına bax")}
              </p>
              <img className='w-2 group-hover:hidden' src={rightArrow} alt="" />
              <img className='w-2 hidden group-hover:block' src={rightArrowHover} alt="" />
            </div>
          </a>
        </div>

        {/* OTHER PROJECTS */}
<div className='grid grid-cols-1 md:grid-cols-4 gap-5 mt-[32px]'>
  {news
    ?.filter(item => String(item.id) !== String(id)) // remove current project
    .slice(0, 4)
    .map((item) => (
      <a key={item.id} href={`/${currentLanguage}/projects/${item?.id}`}>
        
        <div className="relative group w-full border border-[#E5E5E5] rounded-lg overflow-hidden">

          {/* IMAGE */}
          <img
            src={`https://cortex-site.runasp.net/${item.images?.[0]}`}
            className="w-full h-[220px] object-cover" 
            alt=""
          />

          {/* OVERLAY */}
          <div className="
            absolute inset-0
            bg-black/50
            opacity-0
            group-hover:opacity-100
            transition-opacity duration-300
            flex flex-col justify-end 
            p-4
          ">
            <div>
              <p className="text-white text-[18px] font-medium">
                {getLocalizedField(item, 'title')}
              </p>

              <p className="text-white text-[14px] font-medium">
                {getLocalizedField(item, "description")
                  ?.replace(/<[^>]*>/g, '')
                  .slice(0, 80)}...
              </p>
            </div>
          </div>

        </div>
      </a>
  ))}
</div>

      </div>
    </div>
  );
};

export default ProjectDetailItems;